import { _x } from '@safe-wordpress/i18n';

export const timePeriodList = {
	'00-02': _x( '12a - 2a', 'text', 'nelio-ab-testing' ),
	'02-04': _x( '2a - 4a', 'text', 'nelio-ab-testing' ),
	'04-06': _x( '4a - 6a', 'text', 'nelio-ab-testing' ),
	'06-08': _x( '6a - 8a', 'text', 'nelio-ab-testing' ),
	'08-10': _x( '8a - 10a', 'text', 'nelio-ab-testing' ),
	'10-12': _x( '10a - 12p', 'text', 'nelio-ab-testing' ),
	'12-14': _x( '12p - 2p', 'text', 'nelio-ab-testing' ),
	'14-16': _x( '2p - 4p', 'text', 'nelio-ab-testing' ),
	'16-18': _x( '4p - 6p', 'text', 'nelio-ab-testing' ),
	'18-20': _x( '6p - 8p', 'text', 'nelio-ab-testing' ),
	'20-22': _x( '8p - 10p', 'text', 'nelio-ab-testing' ),
	'22-24': _x( '10p - 12a', 'text', 'nelio-ab-testing' ),
};
